import { Component, inject, OnInit, signal } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ReactiveFormsModule, ValidationErrors, Validators } from '@angular/forms';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { GenericFormComponent } from '../../../../../shared/components/generic-form/generic-form.component';
import { AuthService } from '../../../../../core/auth/auth.service';
import { AlertService } from '../../../../../shared/services/alert.service';

@Component({
  selector: 'app-reset-password-form',
  standalone: true,
  imports: [ReactiveFormsModule, RouterLink, GenericFormComponent],
  templateUrl: './reset-password-form.component.html',
  styleUrl: './reset-password-form.component.css',
})
export class ResetPasswordFormComponent implements OnInit {
  private authService: AuthService = inject(AuthService);
  private router: Router = inject(Router);
  private route: ActivatedRoute = inject(ActivatedRoute);
  private fb: FormBuilder = inject(FormBuilder);
  private alertService: AlertService = inject(AlertService);

  token = signal<string | null>(null);
  isLoading = signal(false);
  errorMessage = signal<string | null>(null);
  successMessage = signal<string | null>(null);

  resetPasswordForm: FormGroup = this.fb.group(
    {
      newPassword: ['', [Validators.required, Validators.minLength(6)]],
      confirmPassword: ['', [Validators.required]],
    },
    { validators: this.passwordMatchValidator }
  );

  ngOnInit(): void {
    const tokenParam = this.route.snapshot.queryParams['token'];
    if (tokenParam) {
      this.token.set(tokenParam);
    } else {
      this.errorMessage.set('Token di reset non specificato o non valido.');
    }
  }

  private passwordMatchValidator(group: AbstractControl): ValidationErrors | null {
    const pass = group.get('newPassword')?.value;
    const confirm = group.get('confirmPassword')?.value;
    return pass === confirm ? null : { mismatch: true };
  }

  onSubmit(): void {
    if (this.resetPasswordForm.invalid) {
      this.resetPasswordForm.markAllAsTouched();
      return;
    }

    const currentToken = this.token();
    if (!currentToken) {
      this.errorMessage.set('Token di reset mancante.');
      return;
    }

    this.isLoading.set(true);
    this.errorMessage.set(null);
    this.successMessage.set(null);

    const newPassword = this.resetPasswordForm.value.newPassword;

    this.authService.resetPassword(currentToken, newPassword).subscribe({
      next: (response) => {
        this.isLoading.set(false);
        const msg = response.data || response.message || 'Password aggiornata con successo!';
        this.successMessage.set(msg);
        this.alertService.showSuccess(msg);
        setTimeout(() => {
          this.router.navigate(['/login']);
        }, 2000);
      },
      error: (err) => {
        this.isLoading.set(false);
        const errStr = err?.error?.message || 'Token scaduto o non valido.';
        this.errorMessage.set(errStr);
      },
    });
  }
}
